import React from 'react';
import { Link } from 'react-router-dom';

import routeFactory from '../../../../../../../common/util/routeFactory';

type Props = {
  data: { offering: { id: string } };
  value: string | undefined;
};

export const IssuerNameCellRenderer: React.FC<Props> = ({ data, value }) => {
  const destination = routeFactory.participation.getUrlPath({
    id: data?.offering?.id,
  });

  return value ? <Link to={destination}>{value}</Link> : <React.Fragment>-</React.Fragment>;
};
